"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const xstate_1 = require("xstate");
const prop_types_1 = require("prop-types");
const DirectBook_1 = __importDefault(require("./DirectBook"));
const Actions_1 = require("../../lib/constants/Actions");
const thirdPartyLogin_1 = require("../../lib/constants/thirdPartyLogin");
class DirectBookContainer extends react_1.Component {
    constructor(props) {
        super(props);
        this.handleMachineTransition = (currentState) => {
            this.setState({ currentState });
            this.props.logState(currentState);
        };
        this.handleGoBack = (step) => {
            this.service.send({
                type: Actions_1.GO_BACK,
                data: {
                    step
                }
            });
        };
        this.state = {
            currentState: props.machine.initialState
        };
        this.service = (0, xstate_1.interpret)(props.machine).onTransition(this.handleMachineTransition);
    }
    componentDidMount() {
        this.service.start();
        this.service.send(Actions_1.INITIALIZED);
    }
    componentWillUnmount() {
        this.service.stop();
    }
    render() {
        const { currentState } = this.state;
        return (react_1.default.createElement(DirectBook_1.default, { darkshipFeatureFlags: this.props.darkshipFeatureFlags, onGoBack: this.handleGoBack, currentState: currentState, mapApiKey: this.props.mapApiKey, awsMapConfig: this.props.awsMapConfig, thirdPartyLoginProps: this.props.thirdPartyLoginProps, config: this.props.config, searchMatchEnabled: this.props.searchMatchEnabled, featureFlags: this.props.featureFlags, track: this.props.track, history: this.props.history, apptDensity: this.props.apptDensity, apptPurposeFilterProps: this.props.apptPurposeFilterProps, onScroll: this.props.onScroll }));
    }
}
DirectBookContainer.propTypes = {
    /* eslint-disable react/forbid-prop-types */
    config: prop_types_1.object.isRequired,
    darkshipFeatureFlags: prop_types_1.object,
    searchMatchEnabled: prop_types_1.bool.isRequired,
    machine: (0, prop_types_1.instanceOf)(xstate_1.StateNode).isRequired,
    track: prop_types_1.func.isRequired,
    mapApiKey: prop_types_1.string,
    awsMapConfig: prop_types_1.object,
    thirdPartyLoginProps: (0, prop_types_1.shape)({
        type: (0, prop_types_1.oneOf)(['mychart']).isRequired,
        isLoggedIn: prop_types_1.bool.isRequired,
        login: (0, prop_types_1.shape)({
            url: prop_types_1.string,
            callback: prop_types_1.func.isRequired
        }).isRequired,
        logout: (0, prop_types_1.shape)({
            url: prop_types_1.string,
            callback: prop_types_1.func.isRequired
        }).isRequired,
        errors: (0, prop_types_1.arrayOf)((0, prop_types_1.oneOf)(Object.values(thirdPartyLogin_1.ERROR)))
    }),
    logState: prop_types_1.func,
    /* optional react-router history object for db-widget to control url and forward/back */
    history: (0, prop_types_1.shape)({
        push: prop_types_1.func,
        replace: prop_types_1.func,
        location: (0, prop_types_1.shape)({
            pathname: prop_types_1.string,
            search: prop_types_1.string
        })
    }),
    apptDensity: (0, prop_types_1.oneOf)(['default', 'dense']),
    /* Properties for the appointment purpose filter controls */
    apptPurposeFilterProps: (0, prop_types_1.shape)({
        /* Specifies the minimum number of appointment purposes before the filter controls are displayed */
        minPurposesForFilter: prop_types_1.number,
        /* Labels for rendering the filter controls */
        labels: (0, prop_types_1.shape)({
            noResultsLabel: prop_types_1.string,
            purposeSearchLabel: prop_types_1.string,
            purposeSearchPlaceholderLabel: prop_types_1.string,
            visitTypeAllLabel: prop_types_1.string,
            visitTypeInPersonLabel: prop_types_1.string,
            visitTypeVirtualLabel: prop_types_1.string
        }),
        /* Function executed when the name filter changes */
        onNameFilterChange: prop_types_1.func,
        /* Function executed when the visit type filter changes */
        onVisitTypeFilterChange: prop_types_1.func,
        /* Function executed when the filters are cleared */
        onClearFilters: prop_types_1.func
    }),
    /**
     * Suggest that direct book should render alternate providers at various steps
     */
    featureFlags: (0, prop_types_1.shape)({
        // Suggest alternate providers for step 1
        dbw_suggest_alt_providers_for_step_1: prop_types_1.bool,
        dbw_suggest_alt_providers_for_step_2: prop_types_1.bool,
        dbw_render_in_drawer: prop_types_1.bool
    }),
    onScroll: prop_types_1.func
};
DirectBookContainer.defaultProps = {
    mapApiKey: '',
    logState: () => { },
    history: null
};
exports.default = DirectBookContainer;
//# sourceMappingURL=DirectBookContainer.js.map